<div *ngIf="!voucherCodeValid" class="loader">
  <div class="loader-default">Loading...</div>
</div>
<div *ngIf="voucherCodeValid" class="container container-slim">
  <div class="row">
    <div class="col-md-12">
      <h3 class="text-login text-login-default">Registrierung</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <form (ngSubmit)="onSubmit()" ngNativeValidate>
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
            <input type="email" class="form-control" name="email" id="inputEmail" [(ngModel)]="userInfo.email" placeholder="Email" required>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
            <input type="password" class="form-control" name="password" id="inputPassword" [(ngModel)]="userInfo.password" placeholder="Password" required>
          </div>
        </div>
        <div>
          <password-strength-bar
                [passwordToCheck]="userInfo.password"
                [strengthLabels]="['nutzlos', 'schwach', 'normal', 'stark', 'super']"
                [titlePrefix]="'Passwortstärke: '">
          </password-strength-bar>
        </div>
        <div class="form-group">
          <select class="form-control" name="app" [(ngModel)]="userInfo.app" required>
            <option value="iosApp">iOS</option>
            <option value="androidApp">Android</option>
          </select>
        </div>
        <div class="form-group">
          <label class="checkbox">
            <input type="checkbox" name="dsgvo" id="inputDsgvo" [(ngModel)]="userInfo.dsgvo" required> Hiermit willige ich in die Verarbeitung meiner personenbezogenen Daten zum Zweck der Nutzung der Leada-App ein. / <br/>
            (<a href="https://www.leada.de/datenschutz" target="_blank">Datenschutzerklärung</a>) / <br/>
            I hereby give consent for my personal data to be processed for the purpose of using the Leada app.
            (<a href="https://www.synk-group.com/data-protection-leada/?lang=en" target="_blank">Data Protection Declaration</a>)
        </label>
        </div>
        <div *ngIf="error" class="alert alert-danger" role="alert">
          <span class="glyphicon glyphicon-exclamation-sign"></span>
          {{error}}
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary btn-block">
            Registrieren
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
